// extracted by mini-css-extract-plugin
export default {"wrapper":"RoleConfirmationModal-module__wrapper___m5MsY","radioGroup":"RoleConfirmationModal-module__radioGroup___LsHHz"};